import React from 'react';
import { Menu, Icon } from 'antd';

import common from '../assets/common.js'
import menuList from './menulist.js'

const SubMenu = Menu.SubMenu;

class MenuCon extends React.Component {
  constructor(props){
    super(props);
    const rootOpen = [];
    common.eachObj(menuList.list, function(index, dataItem){
      rootOpen.push(dataItem.key);
    });
    const menu = props.menu;
    const parents = common.lookUpParent(menuList.list, "sub", "key", menu)[0];
    if(parents) var openKey = parents[0]['key'];
    this.state = {
      collapsed : false,
      openKeys:[openKey],
      rootOpen
    }
    // console.log(openKey);
  }
  componentWillReceiveProps(props){
    this.setState({ menu : props.menu})
  }
  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (this.state.rootOpen.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }
  render(){
    const { menu, history } = this.props;
    const superAdmin = this.props.subAdmin?"SUBADMIN":(this.props.superAdmin?"SUPER":"ADMIN");
    const parents = common.lookUpParent(menuList.list, 'sub', 'key', menu)[0];
    const parent = parents[0];
    const showMenu = parent.key;
    const selectKey = window.location.hash.split("#")[1];
    return (
      <Menu
        id="mainMenu"
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[selectKey]}
        defaultOpenKeys={['menu' + showMenu]}
        onOpenChange={this.onOpenChange}
        style={{ lineHeight: '60px' }}
      >
        { menuList.list.map((dataItem, index) => {
            var toPage = "";
            if(parent.key === dataItem.key){
              toPage = function(){
                history.push( dataItem.key );
              }
            } else {
              toPage = function(){
                history.push( dataItem.key );
              }
            }
            let menuOne = null;
            if(dataItem.sub && dataItem.sub.length > 1) {
              menuOne = <SubMenu key={ "menu" +dataItem.key } title={<span><Icon type={ dataItem.icon } /><span>{ dataItem.title }</span></span>}>
                { dataItem.sub.map((item, index) => {
                  var toSub = "";
                  toSub = function() {
                    history.push( item.key );
                  }
                  if(!item.hide) {
                    return <Menu.Item key={ item.key }>
                    <a onClick = { toSub }>
                      <span>{ item.title }</span>
                    </a>
                    </Menu.Item>
                  }
                }) }
              </SubMenu>
            } else {
              menuOne = <Menu.Item key={ dataItem.key }>
                <a onClick={ toPage }>
                  <Icon type={ dataItem.icon } />
                  <span>{ dataItem.title }</span>
                </a>
              </Menu.Item>
            }
            let show = dataItem.authority?dataItem.authority.indexOf(superAdmin) > -1:false;
            // let show = true;
            if(dataItem.hide){
              return "";
            } else {
              if(show){
                return menuOne;
              } else {
                return "";
              }
            }
          })
        }
      </Menu>
    )
  }
}

export default MenuCon;



// WEBPACK FOOTER //
// ./src/index/menu.js